import { EoleEvent } from "@syadem/eole";
import { Appointment } from "./appointment";

export function parseEoleEvent(eoleEvent: EoleEvent): Appointment {
  return {
    uid: eoleEvent.uid,
    dtstart: eoleEvent.dtstart,
    dtend: eoleEvent.dtend,
    duration: eoleEvent.duration,
    description: eoleEvent.description,
    alarms: eoleEvent.alarms,
    summary: eoleEvent.summary,
  };
}
